<template>
  <div class="container">
    <QueryFrame
      :current="page"
      :count="count"
      :disablePage="disablePage"
      @handlePage="handlePage"
      @handlePageSize="handlePageSize"
      @addNew="addNew">
      <div slot="queryParams" class="form">
        <div class="queryContainer">
            <div class="queryItem">
              <goodsSearchItem  v-model.trim='query.nameMix'></goodsSearchItem>
          </div>
          <div class="queryItem">
            <label>付款单号:</label>
            <lk-input :maxlength='100' placeholder='请输入' class="item" clearable
              v-model.trim='query.paymentCode'></lk-input>
          </div>
          <div class="queryItem">
            <label>创建时间:</label>
            <timeStampDatePicker type='daterange' placeholder=" 请选择" class="item" v-model.trim='query.createTime'></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <label>付款方式:</label>
            <lk-select :maxlength='100' class="item" clearable
              v-model.trim='query.supplierPayWay'>
              <lk-option
                v-for="(item) in payWayMap"
                :key="item[0]"
                :value="item[0]">{{ item[1] }}</lk-option>
              </lk-select>
          </div>
          <div class="queryItem">
            <label>供应商名称:</label>
            <SupplierListSelect v-model="query.supplierId"></SupplierListSelect>
          </div>

          <div class="queryItem">
            <label>应付单号:</label>
            <lk-input :maxlength='100' placeholder='请输入' class="item" clearable
              v-model.trim='query.payableCode'></lk-input>
          </div>
          <div class="queryItem">
            <label>验收单号:</label>
            <lk-input :maxlength='100' placeholder='请输入' class="item" clearable
              v-model.trim='query.inspectionCode'></lk-input>
          </div>
          <div class="queryItem" v-if="roleType!==2">
            <label>门店名称:</label>
              <StoreListSelect v-model.trim='query.storeIdList' class="item"></StoreListSelect>
          </div>
          <div class="queryItem">
          <label  >生产企业:</label>
            <lk-input :maxlength='100' placeholder='请输入' class="item" clearable v-model.trim='query.manufacturer'></lk-input>
            </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
  <div slot="table">
    <div class="btns">
      <lk-button type='primary' @click="$router.push({name:'paymentAdd'})" v-if="handlePermission('paymentAdd') ">+新建付款单</lk-button>
      <DownloadButton  @on-click="handleExport" v-if="handlePermission('paymentExcel')"></DownloadButton>
      <!-- <lk-button>生成付款单</lk-button>
      <lk-button>生成应付凭证</lk-button> -->
    </div>
    <lk-table border :columns='columns' :data='tableData' class="cancelTableShadow"></lk-table>
  </div>
</QueryFrame>

  </div>
</template>
<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import finance from '../../services/finance';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
// import DTPModal from '../../components/DTPModal.vue';
import SupplierListSelect from '../../components/SupplierListSelect.vue';
import DownloadButton from '../../components/download/DownloadButton';

export default {
  name: 'payment',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    // DTPModal
    SupplierListSelect,
    DownloadButton,
  },
  computed: {
    roleType() {
      return this.$store.state.user.roleType;
    },
    payWayMap() {
      return this.$store.state.publicParams.payWayMap;
    },
  },
  data() {
    return {
      disablePage: false,
      // rights: {
      //   routers: [],
      //   btns: [],
      // },
      storeList: [],
      statuslist: ['草稿', '审批中', '审批通过', '审批未通过'],
      query: {
        // paymentCode: '',
        createUserName: '',
        createTime: [],
        supplierId: '', //
        // supplierCode: '',
        // invoiceCode: '',
        // invoiceDate: '',
      },
      subcolumns: [
        { title: '应付单号', key: 'payableCode', minWidth: 116 },
        { title: '来源单据', key: 'referCode', minWidth: 116 },
        { title: '商品通用名', key: 'approvedDrugName', minWidth: 116 },
        { title: '规格', key: 'specification', minWidth: 116 },
        { title: '生产企业', key: 'manufacturer', minWidth: 116 },
        { title: '确认单价', key: 'realPriceWithTax', minWidth: 116 },
        { title: '数量', key: 'num', minWidth: 116 },
        { title: '确认税率', key: 'realInputTaxRate', minWidth: 116 },
        { title: '不含税单价', key: 'realPriceAfterTax', minWidth: 116 },
        { title: '单个税额', key: 'realTax', minWidth: 116 },
        { title: '含税总金额', key: 'realTotalPriceBeforeTax', minWidth: 116 },
        { title: '总税额', key: 'realTotalTax', minWidth: 116 },
      ],
      columns: [
        {
          type: 'expand',
          width: 50,
          render: (h, params) => h('lk-table', {
            props: {
              columns: this.subcolumns,
              data: params.row.subList,
            },
          }),
        },
        { title: '付款单号', key: 'code', minWidth: 116 },
        { title: '供应商名称', key: 'supplierName', minWidth: 116 },
        { title: '付款金额', key: 'amountDisplay', minWidth: 116 },
        { title: '已支付金额', key: 'finishPaymentRecordAmount', minWidth: 116 },
        { title: '未支付金额', key: 'unFinishPaymentAmount', minWidth: 116 },
        { title: '创建人', key: 'createUserName', minWidth: 116 },
        { title: '创建时间', key: 'createTime', minWidth: 116 },
        { title: '审批状态', key: 'statusName', minWidth: 116 },
        { title: '最近一期付款审批状态', key: 'lastPayStatusName', minWidth: 160 },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 130,
          render: (h, { row }) => h('div', {
            class: {
              textCenter: true,
            },
          }, [
            this.handlePermission('paymentCheck') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'paymentCheck', params: { id: row.id } });
                },
              },
            }, '查看') : null,
            this.handlePermission('paymentEdit') && row.status !== 6 ? h('lk-button', {
              props: {
                type: 'text',
                disabled: (row.lastPayStatus === 2) && (row.status !== 1 || row.status !== 4),
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'paymentEdit', params: { id: row.id } });
                },
              },
            }, '付款') : null,
          ]),
        },
      ],
      tableData: [],
    };
  },
  methods: {
    clear() {
      this.query = {};
    },
    handleExport() { // 预留对接
      const params = utils.deepClone(this.params);
      delete params.page;
      delete params.size;

      params.queryCondition = utils.getQueryCondition('.queryContainer');
      finance.downloadFinancePaymentList(params).then((res) => {
        if (res.data.error) {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    // handleSearch() {
    //   this.params = utils.deepClone(this.query);
    //   this.handlePage(1, true);
    // },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      if (this.params.createTime) {
        this.params.createTimeStart = this.params.createTime[0];
        this.params.createTimeEnd = this.params.createTime[1];
        delete this.params.createTime;
      } else {
        this.params.createTimeStart = '';
        this.params.createTimeEnd = '';
      }
      finance.getFinancePaymentList(this.params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          const { count, list } = res.data.data;
          this.count = count;
          list.forEach((item) => {
            const result = utils.deepClone(item.financePayment);
            result.finishPaymentRecordAmount = item.finishPaymentRecordAmount;
            result.unFinishPaymentAmount = item.unFinishPaymentAmount;
            result.newPaymentRecordAmount = item.newPaymentRecordAmount;
            result.lastPayStatusName = item.lastPayStatusName;
            result.lastPayStatus = item.lastPayStatus;
            result.createTime = utils.exchangeTime(result.createTime);
            result.subList = [];
            item.financePayableInfoList.forEach((subItem) => {
              const sub = {};
              utils.exchangeTable(subItem, sub);
              sub.realInputTaxRate += '%';
              result.subList.push(sub);
            });
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    addNew() {
      this.$router.push({ name: 'storeAdd' });
    },
  },
  mounted() {
    if (this.roleType !== 2) {
      this.columns.splice(1, 0, { title: '门店名称', key: 'storeName', minWidth: 116 });
    }
    // this.getData();
    this.handleSearch(true);
  },
};
</script>
<style lang="less" scoped>
  .btns{
    margin-bottom: 12px;
    >*{
      margin-right: 16px
      }
    }
</style>
